<template>
  <div>
    <div class="has-text-centered">
      <h2 class="title">{{ $t('pages.loginRegister.register.title') }}</h2>
      <p class="subtitle">{{ $t('pages.loginRegister.register.subtitle') }}</p>
    </div>
    <div class="register-form">
      <form  @submit.prevent="register">
        <b-field label="Email">
          <b-input v-model="email" placeholder="master@status.quo"
                   type="email"
                   icon="email">
          </b-input>
        </b-field>
        <b-field :label="$t('common.username')">
          <b-input v-model="username" placeholder="G08M45T3R"
                   type="text"
                   icon="account">
          </b-input>
        </b-field>
        <b-field :label="$t('common.password')">
          <b-input v-model="password" placeholder="hardly crackable password"
                   type="password"
                   icon="key">
          </b-input>
        </b-field>
        <div class="has-text-centered">
          <button class="button is-light">{{ $t('buttons.register') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ApiAuth from '@/api/auth'
export default {
  data () {
    return {
      email: '',
      username: '',
      password: ''
    }
  },
  methods: {
    register () {
      let body = {
        email: this.email,
        username: this.username,
        password: this.password
      }
      console.log(Vue.http.headers.common['Authorization'])
      ApiAuth.post.register(body).then(response => {
        if (response.body.success) {
          this.$snackbar.open({
            message: 'Vous pouvez désormais vous connecter !',
            position: 'is-bottom-right',
            actionText: 'J\'ai compris.'
          })
        } else {
          this.$snackbar.open({
            message: response.body.message,
            position: 'is-bottom-right',
            actionText: null
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
  .register-form {
    margin-top: 20px;
  }
  input {
    width: 90%;
  }
  .field {
    margin-left: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/components/RegisterForm.vue